import { api } from '@/lib/api'

import { AccountType } from '../features/Accounts/types'
import { BankEligibilityOnboardingState } from '../types'

export function getBankEligibilityOnboardingState(accountType: AccountType) {
  return api.get<BankEligibilityOnboardingState>(
    `/v1/me/bank-accounts/${accountType}/onboarding`,
  )
}
